import React from 'react'
import { Modal, ModalBody, ModalHeader, Table } from 'reactstrap'

const PopUpSecondFold = (props) => {
    const modalStyle = {
        borderBottom: "none",
        padding: "1rem 1rem 0 0"
    }
    return (
        <Modal isOpen={props.showPopUpText} toggle={props.toggleInfoPopup} size="lg"> 
            <ModalHeader style={modalStyle} toggle={props.toggleInfoPopup}></ModalHeader>
            <ModalBody>
                <div className='m-auto' style={{ padding: "0 1rem" }}>
                    <p className='font-size-18 text-muted'>
                        <ol>
                            <li>The analysis is an outcome of back testing the InCred Nifty MLD Aug’25 from 1st Jan 2010 till 14th Jul 2023, and comparing it with the Nifty 50 Index for the same period.</li>
                            <li>The returns considered here are the 2 year rolling returns.</li>
                            <li> Standard deviation (i.e. measure of risk) considered here is computed on the 2 year rolling returns for the same period.</li>
                        </ol><br />
                    </p>
                </div>
                <Table bordered>
                        <thead style={props.isMobile ? {fontSize : '12'} : {fontSize : '16'}}> 
                            <tr>
                                <th></th>
                                <th>Average Returns(x)</th>
                                <th>Standard Deviation (measure of risk) (y)</th>
                                <th>Risk Adjusted Returns (x/y)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>InCred Nifty MLD Aug’25</td>
                                <td>22.9%</td>
                                <td>7.1%</td>
                                <td>3.2x</td>
                            </tr>
                            <tr>
                                <td>Nifty 50 Index</td>
                                <td>25.5%</td>
                                <td>20.0%</td>
                                <td>1.3x</td>
                            </tr>
                        </tbody>
                    </Table>
            </ModalBody>
        </Modal>
    )
}

export default PopUpSecondFold